// Delivery Estimator
// console.log("=== DELIVERY ESTIMATOR LOADED ===");

// Wait for DOM to be ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDeliveryEstimator);
} else {
    initDeliveryEstimator();
}

function initDeliveryEstimator() {
    // console.log("=== INITIALIZING DELIVERY ESTIMATOR ===");

    var estimator = document.querySelector("[data-delivery-estimator]");
    if (!estimator) {
        // console.log("No delivery estimator found");
        return;
    }

    var inputWrapper = estimator.querySelector("[data-delivery-input-wrapper]");
    var pincodeInput = estimator.querySelector("[data-delivery-pincode]");
    var checkBtn = estimator.querySelector("[data-delivery-check]");
    var changeBtn = estimator.querySelector("[data-delivery-change]");
    var loadingEl = estimator.querySelector("[data-delivery-loading]");
    var resultEl = estimator.querySelector("[data-delivery-result]");
    var dateEl = estimator.querySelector("[data-delivery-date]");

    if (!pincodeInput || !checkBtn) {
        // console.error("Required elements not found");
        return;
    }

    // Format date as "Feb 15"
    function formatDate(date) {
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        return months[date.getMonth()] + " " + date.getDate();
    }

    // Calculate delivery date range
    function calculateDeliveryDates() {
        var today = new Date();

        // Start date: today + 3 days
        var startDate = new Date(today);
        startDate.setDate(today.getDate() + 3);

        // End date: today + 6 days
        var endDate = new Date(today);
        endDate.setDate(today.getDate() + 6);

        return {
            start: startDate,
            end: endDate,
            formatted: formatDate(startDate) + " to " + formatDate(endDate),
        };
    }

    // Validate PIN code (Indian PIN codes only)
    function validatePincode(pincode) {
        var cleaned = pincode.replace(/\s/g, "");
        // Indian PIN codes: 6 digits, first digit must be 1-9 (not 0)
        // Valid range: 110001 to 855117
        if (!/^[1-9]\d{5}$/.test(cleaned)) {
            return false;
        }
        // Additional check: PIN code should be within valid Indian range
        var pincodeNum = parseInt(cleaned, 10);
        return pincodeNum >= 110001 && pincodeNum <= 855117;
    }

    // Show loading state
    function showLoading() {
        inputWrapper.style.display = "none";
        resultEl.style.display = "none";
        loadingEl.style.display = "flex";
    }

    // Show result
    function showResult(pincode) {
        loadingEl.style.display = "none";

        // Update input to show entered pincode
        pincodeInput.value = pincode;
        pincodeInput.readOnly = true;

        // Hide Check button, show Change button
        checkBtn.style.display = "none";
        changeBtn.style.display = "inline-flex";

        // Show input wrapper and result
        inputWrapper.style.display = "flex";
        resultEl.style.display = "block";

        // Calculate and display delivery dates
        var dates = calculateDeliveryDates();
        dateEl.textContent = "Estimated Delivery by " + dates.formatted;
    }

    // Reset to input state
    function resetToInput() {
        pincodeInput.value = "";
        pincodeInput.readOnly = false;
        checkBtn.style.display = "inline-flex";
        changeBtn.style.display = "none";
        resultEl.style.display = "none";
        loadingEl.style.display = "none";
        inputWrapper.style.display = "flex";
        localStorage.removeItem("kv_delivery_pincode");
        pincodeInput.focus();
    }

    // Handle check button click
    checkBtn.addEventListener("click", function () {
        var pincode = pincodeInput.value.trim();

        if (!validatePincode(pincode)) {
            alert("Please enter a valid Indian PIN code (6 digits). We currently deliver only within India.");
            pincodeInput.focus();
            return;
        }

        // Show loading
        showLoading();

        // Random delay between 500ms and 1000ms
        var delay = Math.floor(Math.random() * 500) + 500;

        setTimeout(function () {
            localStorage.setItem("kv_delivery_pincode", pincode);
            showResult(pincode);
        }, delay);
    });

    // Handle change button click
    changeBtn.addEventListener("click", function () {
        resetToInput();
    });

    // Handle Enter key in input
    pincodeInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
            checkBtn.click();
        }
    });

    // Only allow numbers in input
    pincodeInput.addEventListener("input", function (e) {
        this.value = this.value.replace(/[^0-9]/g, "");
    });

    // Restore saved pincode on page load
    var savedPincode = localStorage.getItem("kv_delivery_pincode");
    if (savedPincode && validatePincode(savedPincode)) {
        showResult(savedPincode);
    }

    // console.log("=== DELIVERY ESTIMATOR INITIALIZED ===");
}
